import React, { Fragment, useState } from 'react';
import { IChain } from '@sc1/common/utils/constants';
import { useSearchParam, useDeprecatedVaults } from '@sc1/common/hooks';

import { Checkbox, Flex, Card } from '../core';
import { VaultPreview } from './VaultPreview';
import { Label } from 'theme-ui';

export const VaultPreviews = (): JSX.Element => {
  const [showDeprecated, setShowDeprecated] = useState(false);
  const chain = useSearchParam().get('chain', 'all chains') as IChain;
  const { allVaults, filteredVaults, hasDeprecatedVaults } =
    useDeprecatedVaults(chain, showDeprecated);
  if (!allVaults?.length) return <Card>No Vaults on this Network</Card>;
  return (
    <Fragment>
      {hasDeprecatedVaults ? (
        <Flex mt={-3}>
          <Label
            sx={{
              fontSize: 1,
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <Checkbox
              sx={{ userSelect: 'none', cursor: 'pointer' }}
              defaultChecked={showDeprecated}
              onChange={() => setShowDeprecated(!showDeprecated)}
            />
            Show Deprecated Vaults
          </Label>
        </Flex>
      ) : (
        ''
      )}
      {filteredVaults?.map((x) => (
        <VaultPreview
          key={x.chain + x.vaultAddress + (showDeprecated ? 'show' : 'hide')}
          {...x}
        />
      ))}
    </Fragment>
  );
};
